export default class MultiSelectState {
}